import React from "react";
import { StockItemContextProvider } from "../../contexts/stockItemContext";
import { StockMovementContextProvider } from "../../contexts/stockMovementContext";
import StockPage from "./StockPage";

const Stock = () => (
  <StockItemContextProvider>
    <StockMovementContextProvider>
      <StockPage />
    </StockMovementContextProvider>
  </StockItemContextProvider>
);

export default Stock;
